// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

const EbicsProtocolsController = function($scope, PUtill, BlEbicsAvailabilityService, BlEbicsProtocolService,
                                          gettext, gettextCatalog, DatepickerUtils){

    $scope.dateRange = { dateFrom: null, dateTo: null };
    $scope.invalidDatesSpecificError = null;
    $scope.isRequestSent = false;
    $scope.protocols = null;

    var defaultFilterStatusLabel = PUtill.getText('Action');
	$scope.selectedStatusFilter = defaultFilterStatusLabel;

    BlEbicsAvailabilityService.requestEbicsAvailableFlag();

    $scope.isEbicsAvailable = function () {
        return BlEbicsAvailabilityService.isEbicsAvailable();
    };

    $scope.setStatusFilter = function (status) {
		$scope.selectedStatusFilter = status;
        $scope.requestProtocols();
    };

    const filterParameter = function () {
        return $scope.selectedStatusFilter === defaultFilterStatusLabel ? null : $scope.selectedStatusFilter;
    };

    const sendRequest = function () {
        const queryParams = {
            status: filterParameter()
        };
        DatepickerUtils.setSearchParamsWithStringRangeAndRaiseErrorIfNeeded($scope, queryParams, $scope.dateRange);
        $scope.protocols = $scope.paginator(function (options, callback) {
            return BlEbicsProtocolService.query(options, function () {
                callback();
                $scope.isRequestSent = true;
            });
        }, queryParams, 20);
    };

    $scope.requestProtocols = function()
    {
        let validateDates = function()
        {
            //+1 to include last day
            var dateDifference = moment($scope.dateRange.dateTo).startOf('day').diff(moment($scope.dateRange.dateFrom).startOf('day'), 'days') + 1;
            
            if(!$scope.dateRange.dateFrom || !$scope.dateRange.dateTo)
            {
                $scope.invalidDatesSpecificError = gettextCatalog.getString(gettext("Both dates must be picked!"));
                return false;
            }

            if($scope.dateRange.dateFrom > $scope.dateRange.dateTo)
            {
                $scope.invalidDatesSpecificError = gettextCatalog.getString(gettext("The start date must be lower than the end date!"));
                return false;
            }

            if(dateDifference > 31)
            {
                $scope.invalidDatesSpecificError = gettextCatalog.getString(gettext("The date range must not be greater than 1 month!"));
                return false;
            }

            return true;
        }

        $scope.isInvalidDates = false;
        $scope.isRequestSent = false;

        if(validateDates())
        {
            sendRequest();
        }
        else
        {
            $scope.isInvalidDates = true;
        }
    }

    $scope.getUser = function(bankUser)
    {
        return bankUser ? bankUser : gettextCatalog.getString(gettext("BANK"));
    }
};

EbicsProtocolsController.$inject = ['$scope', 'PUtill', 'BlEbicsAvailabilityService','BlEbicsProtocol', 'gettext',
    'gettextCatalog', 'DatepickerUtils'];
